import React from 'react';
import './style.css';

const BadgeStyle = ({ children, ...rest }) => (
  <div className="badge-style" {...rest}>
    {children}
  </div>
);

export default BadgeStyle;
